import { IPublicMenuTheme } from "../../PublicMenu/Helpers/PublicMenuTheme"

export type PublicMenuThemeDesign = Record<string, unknown>

export interface PublicMenuThemeEntity {
  id: number
  companyId: number
  name: string
  design: PublicMenuThemeDesign
  createdAt: string
  updatedAt: string
}

export const publicMenuThemeFromDesign = (design: PublicMenuThemeDesign): IPublicMenuTheme => ({
  cardLayout: design.publicMenuCardLayout as IPublicMenuTheme["cardLayout"],
  primaryColor: String(design.publicMenuPrimaryColor),
  secondaryColor: String(design.publicMenuSecondaryColor),
  accentColor: String(design.publicMenuAccentColor),
  backgroundColor: String(design.publicMenuBackgroundColor),
  surfaceColor: String(design.publicMenuSurfaceColor),
  textColor: String(design.publicMenuTextColor),
  borderColor: String(design.publicMenuBorderColor),
  buttonColor: String(design.publicMenuButtonColor),
  buttonTextColor: String(design.publicMenuButtonTextColor),
  searchBackgroundColor: String(design.publicMenuSearchBackgroundColor),
  searchBorderColor: String(design.publicMenuSearchBorderColor),
  mobileNavBackgroundColor: String(design.publicMenuMobileNavBackgroundColor),
  mobileNavActiveBackgroundColor: String(design.publicMenuMobileNavActiveBackgroundColor),
  mobileNavActiveTextColor: String(design.publicMenuMobileNavActiveTextColor),
  mobileNavActiveIconColor: String(design.publicMenuMobileNavActiveIconColor),
  mobileNavInactiveBackgroundColor: String(design.publicMenuMobileNavInactiveBackgroundColor),
  mobileNavInactiveTextColor: String(design.publicMenuMobileNavInactiveTextColor),
  mobileNavInactiveIconColor: String(design.publicMenuMobileNavInactiveIconColor),
  headerBackgroundColor: String(design.publicMenuHeaderBackgroundColor),
  restaurantNameColor: String(design.publicMenuRestaurantNameColor),
  restaurantDescriptionColor: String(design.publicMenuRestaurantDescriptionColor),
  statusCardBackgroundColor: String(design.publicMenuStatusCardBackgroundColor),
  cartButtonColor: String(design.publicMenuCartButtonColor),
  cartBackgroundColor: String(design.publicMenuCartBackgroundColor),
  cartBorderColor: String(design.publicMenuCartBorderColor),
  cartTitleTextColor: String(design.publicMenuCartTitleTextColor),
  cartDescriptionTextColor: String(design.publicMenuCartDescriptionTextColor),
  cartTotalLabelTextColor: String(design.publicMenuCartTotalLabelTextColor),
  cartTotalValueTextColor: String(design.publicMenuCartTotalValueTextColor),
  emptyStateTitleColor: String(design.publicMenuEmptyStateTitleColor),
  emptyStateDescriptionColor: String(design.publicMenuEmptyStateDescriptionColor),
  categoryBackgroundColor: String(design.publicMenuCategoryBackgroundColor),
  categoryBorderColor: String(design.publicMenuCategoryBorderColor),
  categoryDividerColor: String(design.publicMenuCategoryDividerColor),
  loginButtonBackgroundColor: String(design.publicMenuLoginButtonBackgroundColor),
  loginButtonTextColor: String(design.publicMenuLoginButtonTextColor),
  shareButtonBackgroundColor: String(design.publicMenuShareButtonBackgroundColor),
  shareButtonTextColor: String(design.publicMenuShareButtonTextColor),
  serviceSelectorBackgroundColor: String(design.publicMenuServiceSelectorBackgroundColor),
  serviceSelectorTextColor: String(design.publicMenuServiceSelectorTextColor),
  serviceSelectorActiveBackgroundColor: String(design.publicMenuServiceSelectorActiveBackgroundColor),
  serviceSelectorActiveTextColor: String(design.publicMenuServiceSelectorActiveTextColor),
  borderThickness: Number(design.publicMenuBorderThickness),
  highlightPromotions: Boolean(design.publicMenuHighlightPromotions),
  compactCategories: Boolean(design.publicMenuCompactCategories),
  useGradientHeader: Boolean(design.publicMenuUseGradientHeader),
})
